
  export function handleChange(event) {
    var value = event.target.type==="checkbox" ? event.target.checked : event.target.value
    this.setState({[event.target.name]: value})
  }


  export function toDateFormat(value) {
    return value.split('/').reverse().join("-");
  }


  export function handleChangeCapitalizeWords(event) {
    var splitValue = event.target.value.split(' ');
    for (var i = 0; i < splitValue.length; i++) {
      splitValue[i] = splitValue[i].charAt(0).toUpperCase() + splitValue[i].substring(1);
    }
    var valueCapitalized = splitValue.join(' ');
    this.setState({[event.target.name]: valueCapitalized})
  }

  export function handleChangeToUpper(event) {
      this.setState({[event.target.name]: event.target.value.toUpperCase()})
  }
  export function checkInvalid(fieldName) {
    return (this.validate || this.state.fieldsTouched.includes(fieldName)) && (this.errorFor(fieldName) !== "")
  }

  export function errorFor(field) {
    return this.state.validationErrors[field] || "";
  }



  export function setFieldsTouched(event) {
    if (!this.state.fieldsTouched.includes(event.target.name)) {
      this.setState({fieldsTouched: this.state.fieldsTouched.concat(event.target.name)})
    }
  }



// WEBPACK FOOTER //
// ./src/registrationform/FormLogic.jsx